module.exports = __webpack_public_path__ + "static/img/animals12.680a8931.png";